export default {"src":"/_next/static/media/shareIos_24.e3c466a0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};